import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import searchIcon from '../../images/common/search.svg';
import Color from '../../styles/common/Color';
import { Chip } from '../Parts/Chip';
import {
  DialogBox,
  Contents,
  SearchBoxWrapper,
  SearchBoxInputField,
  SearchImage,
  CheckboxWrapper,
  Checkbox,
  DefaultCheckbox,
  GroupsWrapper,
  GroupNameWrapper,
  ChipWrapper,
  GroupName,
  CheckboxLabel,
} from './Styles/SelectGroupDialogStyles';

/**
 * グループを選択するダイアログを表示するコンポーネント
 *
 * @component
 *
 * @param {Object} props
 * @param {Array} props.groups - ダイアログに表示するグループのリスト。
 * @param {Function} props.onSelect - グループが選択されたときに呼び出されるコールバック関数。選択されたグループの`id`を引数として受け取る。
 *
 * @returns {ReactElement}
 */
const SelectGroupDialog = ({ groups, onSelect }) => {
  const intl = useIntl();
  const { formatMessage } = intl;
  const disabledText = formatMessage({ id: 'common.label.disabled' });
  const [showDisabledGroups, setShowDisabledGroups] = useState(false);
  const [filterWord, setFilterWord] = useState('');
  return (
    <DialogBox role="presentation" onClick={e => e.stopPropagation()}>
      <Contents>
        <SearchBoxWrapper>
          <SearchBoxInputField
            id="SetGroupDialogTextField"
            type="text"
            defaultValue={filterWord}
            onChange={e => setFilterWord(e.target.value)}
          />
          <SearchImage src={searchIcon} alt="search" />
        </SearchBoxWrapper>
        <CheckboxWrapper>
          <Checkbox>
            <DefaultCheckbox
              id="SetGroupCheckbox"
              type="checkbox"
              defaultChecked={showDisabledGroups}
              onClick={() => setShowDisabledGroups(!showDisabledGroups)}
            />
            <CheckboxLabel
              className="checkBoxLabel"
              htmlFor="SetGroupCheckbox"
            />
            <FormattedMessage id="selectGroup.dialog.checkbox.label" />
          </Checkbox>
        </CheckboxWrapper>
        <GroupsWrapper>
          {/* TODO:「すべて」項目追加する */}
          {/* <GroupNameWrapper
            className="clickableItem"
            key="SetGroupDialog-All"
            onClick={() => {}} // TODO: 全グループ選択時の処理
          >
            <GroupName>
              {formatMessage({ id: 'selectGroup.dialog.allGroups' })}
            </GroupName>
          </GroupNameWrapper> */}
          {groups
            .filter(group => {
              const { isUsable, name } = group;
              return (
                (showDisabledGroups || isUsable) && name.includes(filterWord)
              );
            })
            .map(group => {
              const { isUsable, id, name } = group;
              const key = `SetGroupDialog-${id}`;
              return (
                <GroupNameWrapper
                  className="clickableItem"
                  id={key}
                  key={key}
                  onClick={() => onSelect(id)}
                >
                  {!isUsable && (
                    <ChipWrapper>
                      <Chip text={disabledText} bgColor={Color.disabled} />
                    </ChipWrapper>
                  )}
                  <GroupName>{name}</GroupName>
                </GroupNameWrapper>
              );
            })}
        </GroupsWrapper>
      </Contents>
    </DialogBox>
  );
};

SelectGroupDialog.propTypes = {
  groups: PropTypes.array.isRequired,
  onSelect: PropTypes.func.isRequired,
};

export default SelectGroupDialog;
